module.exports = __webpack_public_path__ + "img/156.7e9d8490.jpg";